import type { QuestionImagepickerModelData } from '@coorum-research/shared-common/types/survey-json.type'
import type { Question } from 'survey-core'

type Props = {
  question: Question
}

/**
 * answer 回答表示用のコンポーネント
 * question type === 'imagepicker'
 */
export function SurveyQuestionAnswerImagepicker({ question }: Props) {
  const modelData = question.toJSON() as QuestionImagepickerModelData

  if (question.value === undefined) {
    return null
  }

  /**
   * 単一選択の場合は string 、複数選択の場合は string[] と値が異なるため、
   * 単一選択の場合は string[] に変換する
   */
  const choiceIds = (
    typeof question.value === 'string' ? [question.value] : question.value
  ) as string[]
  const selectedChoices = modelData.choices?.filter(choice => choiceIds.includes(choice.value)) ?? []

  // 単一選択の場合は中央寄せの1カラム、複数選択の場合は2カラムとする
  const rootClassName = selectedChoices.length > 1
    ? 'sd-selectbase sd-imagepicker grid grid-cols-2 auto-cols-auto gap-2'
    : 'sd-selectbase sd-imagepicker align-center grid justify-center'

  return (
    <>
      <fieldset className={rootClassName}>
        <legend className="sv-hidden">{question.title}</legend>
        {selectedChoices.map((choice) => {
          const { value, text, imageLink } = choice
          const caption = text ?? value
          return (
            <div className="sd-imagepicker__item sd-imagepicker__item--inline" key={choice.value}>
              <label className="sd-imagepicker__label">
                <div className="sd-imagepicker__item-decorator">
                  <div className="sd-imagepicker__image-container border rounded-[6px] overflow-hidden">
                    <img width="200" height="150" src={imageLink} alt={value} className="sd-imagepicker__image rounded-none object-cover" />
                  </div>
                  {modelData.showCaption && caption && (
                    <span className="sd-imagepicker__text"><span className="sv-string-viewer">{caption}</span></span>
                  )}
                </div>
              </label>
            </div>
          )
        })}
      </fieldset>
      {modelData.showCommentArea && question.comment.length > 0 && <div className="mt-2">{question.comment}</div>}
    </>
  )
}
